import request from '@/utils/request'
import { buildApiV1Path } from '@/utils/apiPath'

export interface SiteQueryParams {
  page?: number
  pageSize?: number
  studyId?: string
  type?: SiteType
  status?: string
  orgId?: string
  keyword?: string
  sortBy?: 'createdAt' | 'updatedAt' | 'siteCode'
  sortOrder?: 'asc' | 'desc'
}

// 研究中心状态类型定义
export type SiteStatus = 'ACTIVE' | 'INACTIVE'

// 研究中心类型定义
export type SiteType =
  | 'RESEARCH_CENTER'
  | 'SPONSOR'
  | 'CONTRACT_RESEARCH_ORGANIZATION'
  | 'DATA_UNIT'
  | 'STATISTICS_UNIT'
  | 'PHARMACOVIGILANCE_UNIT'
  | 'TESTING_UNIT'
  | 'SMO'
  | 'AUDIT_UNIT'
  | 'OTHER'

export interface SiteFormData {
  studyId: string
  orgId: string
  siteCode?: string // Optional for non-RESEARCH_CENTER types
  type: SiteType
  status?: SiteStatus
  sampleTarget?: number // Optional for non-RESEARCH_CENTER types
  notes?: string
}

export interface SiteResponse {
  id: string
  studyId: string
  orgId: string
  organizationName?: string
  siteCode: string
  type: SiteType
  status: SiteStatus
  sampleTarget: number
  sampleActual: number
  notes?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  createdAt: string
  updatedAt: string
}

export interface SiteListResponse {
  success: boolean
  data: SiteResponse[]
  pagination: {
    page: number
    pageSize: number
    total: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
  }
}

/**
 * 获取研究中心列表
 */
export function getSites(params: SiteQueryParams): Promise<SiteListResponse> {
  return request.get(buildApiV1Path('sites'), { params })
}

/**
 * 获取研究中心详情
 */
export function getSite(id: string): Promise<SiteResponse> {
  return request.get(buildApiV1Path('sites', id))
}

/**
 * 创建研究中心
 */
export function createSite(data: SiteFormData): Promise<SiteResponse> {
  return request.post(buildApiV1Path('sites'), data)
}

/**
 * 更新研究中心
 */
export function updateSite(id: string, data: Partial<SiteFormData>): Promise<SiteResponse> {
  return request.put(buildApiV1Path('sites', id), data)
}

/**
 * 删除研究中心
 */
export function deleteSite(id: string): Promise<void> {
  return request.delete(buildApiV1Path('sites', id))
}

/**
 * 激活研究中心
 */
export function activateSite(id: string): Promise<{ success: boolean; data: SiteResponse }> {
  return request.post(buildApiV1Path('sites', id, 'activate'))
}

/**
 * 停用研究中心
 */
export function deactivateSite(id: string): Promise<{ success: boolean; data: SiteResponse }> {
  return request.post(buildApiV1Path('sites', id, 'deactivate'))
}
